import { Share2 } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function Share2Icon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Share2
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
